import React from 'react';
import JobDetail from "../components/JobDetail";

const JobDetailPage = () => {
    return (
        <div>
            <JobDetail />
        </div>
    );
};

export default JobDetailPage;
